import axiosIns from '@/libs/axios'
import {getUserData} from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    addProfessional(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/professional', data,
            {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
            }
            )
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    fetchProfessionals(ctx, queryParams){
      return new Promise((resolve, reject) => {
          axiosIns.get('/professional/list', {params:queryParams})
          .then(response=>resolve(response))
          .catch(error=>reject(error))
      })
    },
    updateProfessional(ctx, data) {
      return new Promise((resolve, reject) => {
          axiosIns.post('/professional', data,
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
          )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteProfessional(ctx, queryParams)
    {
      return new Promise((resolve, reject) => {
        axiosIns.delete('/professional', {params:queryParams})
        .then(response=>resolve(response))
        .catch(error=>reject(error))
    })
    }




  },
}
